import React from "react";
import {
  FaMoneyBillWave,
  FaGlobeAmericas,
  FaCreditCard,
  FaUserCheck,
  FaShieldAlt,
  FaHeadset,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaTelegram,
} from "react-icons/fa";

const GogoCabFeatures = () => {
  // WhatsApp configuration
  const whatsappNumber = "917349519354"; // Without + for WhatsApp
  const whatsappMessage = "Hello! I'm interested in your cab services. Can you please provide more information?";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  // Telegram configuration
  const telegramUsername = "PlusCabsSupport"; // Your Telegram username
  const telegramUrl = `https://t.me/${telegramUsername}`;

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  const handleTelegramClick = (e) => {
    e.stopPropagation(); // Prevent triggering parent click
    window.open(telegramUrl, '_blank');
  };

  const features = [
    {
      icon: <FaMoneyBillWave className="text-green-500 text-xl" />,
      title: "Affordable Pricing",
      desc: "Clear, no-hidden-fee pricing.",
    },
    {
      icon: <FaGlobeAmericas className="text-blue-500 text-xl" />,
      title: "International Support",
      desc: "WhatsApp / Telegram available",
      isClickable: true,
      onClick: handleWhatsAppClick,
      subIcon: (
        <div className="flex mt-1 space-x-3">
          <button 
            onClick={handleWhatsAppClick}
            className="text-green-600 hover:text-green-700 transition-colors duration-200 flex items-center gap-1 bg-green-50 hover:bg-green-100 px-2 py-1 rounded-md"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp className="text-green-600 text-sm" />
            <span className="text-xs font-medium">WhatsApp</span>
          </button>
          <button 
            onClick={handleTelegramClick}
            className="text-blue-400 hover:text-blue-500 transition-colors duration-200 flex items-center gap-1 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-md"
            aria-label="Chat on Telegram"
          >
            <FaTelegram className="text-blue-400 text-sm" />
            <span className="text-xs font-medium">Telegram</span>
          </button>
        </div>
      ),
    },
    {
      icon: <FaCreditCard className="text-purple-500 text-xl" />,
      title: "Multiple Payments",
      desc: "UPI, Cash, Card, online etc",
    },
    {
      icon: <FaUserCheck className="text-yellow-500 text-xl" />,
      title: "Trusted Drivers",
      desc: "Experienced drivers",
    },
    {
      icon: <FaShieldAlt className="text-red-400 text-xl" />,
      title: "Safety & Comfort",
      desc: "Your safety comes first",
    },
    {
      icon: <FaHeadset className="text-indigo-500 text-xl" />,
      title: "24/7 Support",
      desc: "Always here to help",
    },
  ];

  return (
    <div className="min-h-fit bg-gradient-to-br from-cyan-50 to-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header - More compact */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Features of <span className="text-yellow-500">Plus Cabs</span>
          </h1>
          <p className="text-lg text-gray-600">
            Everything you need for a comfortable ride
          </p>
        </div>

        {/* Features Grid - More compact spacing */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              onClick={feature.onClick}
              className={`bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition-all duration-200 border border-gray-100 ${
                feature.isClickable 
                  ? 'cursor-pointer hover:border-green-500 hover:bg-green-50/30' 
                  : 'hover:border-blue-100'
              }`}
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4 mt-1">{feature.icon}</div>
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-800 mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{feature.desc}</p>
                  {feature.subIcon && (
                    <div onClick={(e) => e.stopPropagation()}>
                      {feature.subIcon}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Floating WhatsApp Button (optional) */}
        <div className="fixed bottom-6 right-6 z-50">
          {/* <button
            onClick={handleWhatsAppClick}
            className="flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 cursor-pointer group relative"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp size={28} />
            <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
              Chat with us
            </span>
          </button> */}
        </div>

        {/* Footer note - Smaller */}
        <div className="text-center mt-10 text-gray-500 text-sm">
          <p>Your reliable ride, anytime, anywhere.</p>
        </div>
      </div>
    </div>
  );
};

export default GogoCabFeatures;